import { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router';
import { useCalculators } from '../../hooks/use-calculators';
import { usesSplitOpenApiSpecs } from '../../versions/split-openapi';
import { useVersion } from '../../versions/url-version';
import { docSlug } from '../../versions/versions';
import CalculatorChooser from './CalculatorChooser';
import LegacyScalarReference from './LegacyScalarReference';
import ScalarReference from './ScalarReference';

/** Falls back to the calculator chooser when this version does not have the calculator, e.g. after switching */
function KnownCalculator({
  version,
  calculator,
  children,
}: {
  version: string;
  calculator: string;
  children: ReactNode;
}) {
  const { calculators } = useCalculators(version);

  if (calculators && !calculators.includes(calculator)) {
    return <Navigate to={`/api/${docSlug(version)}/api-reference`} replace />;
  }

  return children;
}

function ApiDocs() {
  const { calculator } = useParams();
  const version = useVersion();

  if (usesSplitOpenApiSpecs(version)) {
    if (!calculator) {
      return <CalculatorChooser version={version} />;
    }

    return (
      <KnownCalculator version={version} calculator={calculator}>
        <ScalarReference key={`${version}/${calculator}`} version={version} calculator={calculator} />
      </KnownCalculator>
    );
  }

  return <LegacyScalarReference version={version} calculator={calculator} />;
}

export default ApiDocs;
